<template>
  <div>
    <CampTab :index="index" @tap="tapFn"></CampTab>
    <el-card v-if="index === 1">
      <el-row :gutter="15">
        <el-col :span="6" v-for="(item, i) in campList1" :key="i" @click="nextPage">
          <div class="camp-item" @click="goCampDetail(item.id)">
          <img class="bg" :src="item.coverUrl" alt="">
          <div class="panel">
            <div class="name">{{ item.productName }}</div>
            <div class="enName">{{ item.enName }}</div>
            <!-- <div class="flex">
              <div>{{ item.place }}</div>
              <div>{{ item.duration }}</div>
            </div> -->
            <div class="btns">
              <div class="btn" @click="handleToPage(item)">报名列表</div>
              <div class="btn" @click="handleToPage2(item)">设置折扣</div>
            </div>
            <!-- <div class="price">{{ item.price }}</div> -->
          </div>
        </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card v-if="index === 0">
      <el-row :gutter="15">
        <el-col :span="6" v-for="(item, i) in campList2" :key="i">
          <div class="camp-item" @click="goCampDetail(item.id)">
          <img class="bg" :src="item.coverUrl" alt="">
          <div class="panel">
            <div class="name">{{ item.productName }}</div>
            <div class="enName">{{ item.enName }}</div>
            <!-- <div class="flex">
              <div>{{ item.place }}</div>
              <div>{{ item.duration }}</div>
            </div> -->
            <!-- <div class="price">{{ item.price }}</div> -->
            <div class="btns">
              <div class="btn" @click="handleToPage(item)">报名列表</div>
              <div class="btn" @click="handleToPage2(item)">设置折扣</div>
            </div>
          </div>
        </div>
        </el-col>
      </el-row>
    </el-card>
    <OfflineOrder projectType="CAMP" ref="contract"></OfflineOrder>

  </div>
</template>

<script>
import CampTab from '@/components/camp_tab_component.vue'
import OfflineOrder from '../product_Management/order/offline_order.vue'

export default {
  name: 'marketingOperationsHome',
  components: {
    CampTab, OfflineOrder
  },
  data () {
    return {
      index: 0,
      campList1: [
        {
          id: 13,
          productName: 'WSA世界杯训练营',
          enName: 'Spelling Bee World Cup',
          description: '',
          price: '¥8000',
          place: '上海',
          duration: '',
          coverUrl: 'https://cdn.spbcn.org/spbcnapp/camp/coverImg/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20260313184148_2583_30.jpg'
        },
        // {
        //   id: 14,
        //   productName: 'ITSO团体赛夏训营',
        //   enName: 'ITSO Summer Tournament',
        //   description: '',
        //   price: '¥8000',
        //   place: '上海',
        //   duration: '',
        //   coverUrl: 'https://cdn.spbcn.org/spbcnapp/camp/coverImg/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20260702150829_175_56.jpg'
        // },
        {
          id: -1,
          productName: 'NASCC北美冠军训练营',
          enName: 'North America Spelling Champion Challenge',
          description: '',
          price: '¥8000',
          place: '美国',
          duration: '',
          coverUrl: 'https://cdn.spbcn.org/spbcnapp/camp/coverImg/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20260707161553_201_56.png'
        },
        {
          id: -1,
          productName: 'ASBC亚洲杯训练营',
          enName: 'Asian Spelling Bee Cup',
          description: '',
          price: '¥8000',
          place: '北京',
          duration: '',
          coverUrl: 'https://cdn.spbcn.org/spbcnapp/camp/coverImg/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20260707161746_202_56.png'
        }
      ],
      campList2: [
        {
          id: 10,
          productName: '华北站',
          description: '',
          price: '¥8000',
          place: '北京',
          duration: '',
          coverUrl: 'https://cdn.spbcn.org/spbcnapp/2025ui/camp/bg_huabei.png'
        },
        {
          id: 11,
          productName: '华东站',
          description: '',
          price: '¥8000',
          place: '上海',
          duration: '',
          coverUrl: 'https://cdn.spbcn.org/spbcnapp/2025ui/camp/bg_huadong.png'
        },
        {
          id: 12,
          productName: '华南站',
          description: '',
          price: '¥8000',
          place: '深圳',
          duration: '',
          coverUrl: 'https://cdn.spbcn.org/spbcnapp/2025ui/camp/bg_huanan.png'
        }
      ]
    }
  },
  created () {
  },
  methods: {
    tapFn (index) {
      this.index = index
    },
    handleToPage (item) {
      if (item.id === -1) return
      this.$router.push('/raceManagement/camp/campCampersData?campId=' + item.id)
    },
    handleToPage2 (item) {
      if (item.id === -1) return
      this.$router.push('/raceManagement/camp/campDetailsData?type=sale&campId=' + item.id)
    }
  }
}
</script>

<style lang="less" scoped>
.btns{
  // height: 30px;
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .btn{
    display: inline-block;
    min-width: 66px;
    padding: 0 10px;
    box-sizing: border-box;
    height: 24px;
    text-align: center;
    line-height: 24px;
    border-radius: 6px;
    margin-right: 10px;
    margin-top: 6px;
    font-size: 12px;
    cursor: pointer;
    color: #fff;
    background-color: rgb(7, 17, 96);
    &:hover{
      box-shadow: inset 0 0 10px rgba(50, 72, 241, 0.8);
      color: rgb(7, 17, 96);
      background-color: #fff;
    }
  }
}
.camp-item{
    width: 100%;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 10px;
    position: relative;
    cursor: pointer;
    margin-bottom: 20px;
    &:hover{
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.4);
    }
    .bg{
      width: 100%;
      height: 120px;
      object-fit: cover;
      border-radius: 10px 10px 0 0;
    }
    .panel{
      padding: 2px 12px 10px;
      .name{
        color: #000;
        font-size: 16px;
        font-weight: bold;
      }
      .enName{
        color: #000;
        font-size: 11px;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .flex{
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #969696;
        font-size: 12px;
      }
      .price{
        font-weight: bold;
        font-size: 18px;
        color: #f00;
        margin-top: 10px;
      }
      .date{
        color: #969696;
        font-size: 12px;
        margin-top: 8px;
        text-align: right;
      }
    }
  }
  .paper-card2{
  cursor: pointer;
  height: 240px;
  width: 100%;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 12px 0px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img{
    width: 120px;
    height: 120px;
    margin-bottom: 10px;
  }
  font-size: 16px;
  color: #79BBFF;
}
</style>
